import { render, staticRenderFns } from "./afteraction_reports.vue?vue&type=template&id=8c619f4c&scoped=true&"
import script from "./afteraction_reports.vue?vue&type=script&lang=js&"
export * from "./afteraction_reports.vue?vue&type=script&lang=js&"
import style0 from "./afteraction_reports.vue?vue&type=style&index=0&id=8c619f4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c619f4c",
  null
  
)

export default component.exports